import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthShell, AuthField } from "@/components/AuthShell";
import { useAuth, formatApiError } from "@/context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const user = await login(email, password);
      const dest = user.role === "admin" ? "/admin" : user.role === "partner" ? "/partner" : "/client";
      navigate(dest);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="Welcome back"
      subtitle="Log in to your Aliwer client or partner portal."
      image="https://static.prod-images.emergentagent.com/jobs/a7857c63-2010-4de3-a354-ef80fc69c639/images/29c5a35a6953ad6be50a2bfca7e8fe84874ff7ea36a30de0c488e32f298c2cca.png"
      foot={
        <>
          New to Aliwer?{" "}
          <Link to="/register" className="text-paper underline underline-offset-4" data-testid="to-register-link">
            Create an account
          </Link>
        </>
      }
    >
      <form onSubmit={submit} className="space-y-4" data-testid="login-form">
        <AuthField
          label="Email"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          testid="login-email"
        />
        <AuthField
          label="Password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
          testid="login-password"
        />
        {error && (
          <p className="text-sm text-red-400" data-testid="login-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading}
          data-testid="login-submit"
          className="w-full rounded-full bg-paper text-black text-sm font-medium py-3.5 hover:bg-white transition-colors disabled:opacity-60"
        >
          {loading ? "Signing in…" : "Log in"}
        </button>
      </form>
    </AuthShell>
  );
}
